import React from 'react'
import ModalBasic from '../../component/ModalBasic'
import TextInput from '../../../components/UIComponent/TextInput'
import MultiSelectDropdown from '../../../components/dropdown/MultiSelectDropdown'
import { AgGridReact } from "ag-grid-react";

export const itemColdefs = [
    {
        field: "itemName",
        headerName: "Item name",
        minWidth: window.innerWidth * 0.2,
        flex: 1.5,
        filter: true,
    },
    {
        field: "stock",
        headerName: "Stock",
        minWidth: window.innerWidth * 0.06,
        flex: 0.6,
        filter: true,
    },
    {
        field: "quantity",
        headerName: "Quantity",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
    },
    // {
    //     field: "pendingQty",
    //     headerName: "Pending Qty",
    //     minWidth: window.innerWidth * 0.1,
    //     flex: 1,
    //     filter: true,
    // },
    {
        field: "returnQuantity",
        headerName: "Return Quantity",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
        editable: true,
    },
    {
        field: "itemRemarks",
        headerName: "Item Remarks",
        minWidth: window.innerWidth * 0.1,
        flex: 1,
        filter: true,
        editable: true,
    },
];

export const BackToStorePopup = (props) => {
    return (
        <ModalBasic
            id="back-to-store"
            classParams="!w-[75%] overflow-y-auto"
            modalOpen={props.isModalOpen}
            setModalOpen={props.setOpenModel}
        >
            <div className='input-fields p-[30px]'>
                <span className="text-blue text-[16px] font-semibold">Transfer inward details</span>
                <div className='item-grp grid grid-cols-5 gap-2.5 mt-3 mb-2 pb-[8px] border-b border-slate-200 items-start'>
                    <div className='input-grp'>
                        <label>Inward no</label>
                        <TextInput type='text'
                            id='inwardNo' name='inwardNo'
                            value={props.transferObject.inwardNo}
                            handleChange={(event) => props.handleChange(event, 'inwardNo')}
                            className={props.validState?.error?.inwardNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Date</label>
                        <TextInput type='date'
                            id='date' name='date'
                            value={props.transferObject.date}
                            handleChange={(event) => props.handleChange(event, 'date')}
                            className={props.validState?.error?.date !== undefined ? "error" : ""}
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Ref. no</label>
                        <TextInput type='text'
                            id='referenceNo' name='referenceNo'
                            value={props.transferObject.referenceNo}
                            handleChange={(event) => props.handleChange(event, 'referenceNo')}
                            className={props.validState?.error?.referenceNo !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Ref. date</label>
                        <TextInput type='date'
                            id='referenceDate' name='referenceDate'
                            value={props.transferObject.referenceDate}
                            handleChange={(event) => props.handleChange(event, 'referenceDate')}
                            className={props.validState?.error?.referenceDate !== undefined ? "error" : ""}
                            disabled
                        />
                    </div>
                    <div className='input-grp'>
                        <label>Transfer no</label>
                        <MultiSelectDropdown
                            drpIdentity="Select transfer"
                            options={props.transferObject.transferList}
                            value={props.transferObject.idTransferLocation > 0 ? props.transferObject.transferList.find(x => x.value === props.transferObject.idTransferLocation) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idTransferLocation")
                            }
                            className={props.validState?.error?.idTransferLocation !== undefined ? "error" : ""}
                        />

                    </div>
                    <div className='input-grp'>
                        <label>Transfer from</label>
                        <MultiSelectDropdown
                            drpIdentity="Select transfer"
                            options={props.transferObject.transferFromList}
                            value={props.transferObject.idPlantLocation > 0 ? props.transferObject.transferFromList.find(x => x.value === props.transferObject.idPlantLocation) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idPlantLocation")
                            }
                            className={props.validState?.error?.idPlantLocation !== undefined ? "error" : ""}
                            isDisabled={true}
                        />
                        {/* <TextInput type='text'
                            id='idPlantLocation' name='idPlantLocation'
                            value={props.transferObject.idPlantLocation}
                            handleChange={(event) => props.handleChange(event, 'idPlantLocation')}
                            className={props.validState?.error?.idPlantLocation !== undefined ? "error" : ""}
                            disabled
                        /> */}
                    </div>
                    <div className='input-grp'>
                        <label>Transfer to</label>
                        {/* <TextInput type='text'
                            id='idPlantLocationToTransfer' name='idPlantLocationToTransfer'
                            value={props.transferObject.idPlantLocationToTransfer}
                            handleChange={(event) => props.handleChange(event, 'idPlantLocationToTransfer')}
                            className={props.validState?.error?.idPlantLocationToTransfer !== undefined ? "error" : ""}
                            disabled
                        /> */}
                        <MultiSelectDropdown
                            drpIdentity="Select transfer"
                            options={props.transferObject.transferToList}
                            value={props.transferObject.idPlantLocationToTransfer > 0 ? props.transferObject.transferToList.find(x => x.value === props.transferObject.idPlantLocationToTransfer) : 0}
                            onChange={(event) =>
                                props.handleChangeForDropdown(event, "idPlantLocationToTransfer")
                            }
                            className={props.validState?.error?.idPlantLocationToTransfer !== undefined ? "error" : ""}
                            isDisabled={true}
                        />
                    </div>
                </div>
                <div className="process-table h-[40vh] mt-2.5">
                    <div className="table-inner h-full">
                        <AgGridReact
                            rowData={props.itemRowData}
                            columnDefs={itemColdefs}
                            onCellClicked={props.handleCellClickItemList}
                        //disabled
                        //onGridReady={props.onGridReady}
                        //overlayLoadingTemplate={'<span class="ag-overlay-loading-center">Loading data...</span>'}
                        //overlayNoRowsTemplate="<span'>No Rows To Show</span>"
                        />
                    </div>
                </div>
                <div className='btn-total flex items-end justify-between mt-[35px]'>
                    <div className='btn-grp flex gap-2.5'>
                        {props.isLoading ?
                            <button className="update-btn btns !cursor-not-allowed  h-[33px]">
                                <div className="w-5 h-5 border-4 border-dashed rounded-full animate-spin border-white mx-auto"></div>
                            </button>
                            :
                            <button className="update-btn btns" onClick={() => props.submit()}>Save</button>
                        }
                        {/* <button className="edit-btn btns">Print</button>
                        <button className="save-btn btns">Preview</button> */}
                        <button className="delete-btn btns" onClick={() => props.close()}>Cancel</button>
                    </div>
                </div>
            </div>
        </ModalBasic>
    )
}